var map = {
	"./brand/classic/metadata.json": 77027,
	"./brand/csp/metadata.json": 61453,
	"./brand/federal/metadata.json": 13852,
	"./brand/harvester/metadata.json": 94649,
	"./brand/rgs/metadata.json": 38123,
	"./brand/suse/metadata.json": 58426,
	"./data/aws-regions.json": 83139,
	"./data/ec2-instance-groups.json": 75207,
	"assets/brand/classic/metadata.json": 77027,
	"assets/brand/csp/metadata.json": 61453,
	"assets/brand/federal/metadata.json": 13852,
	"assets/brand/harvester/metadata.json": 94649,
	"assets/brand/rgs/metadata.json": 38123,
	"assets/brand/suse/metadata.json": 58426,
	"assets/data/aws-regions.json": 83139,
	"assets/data/ec2-instance-groups.json": 75207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36045;